module.exports = __webpack_public_path__ + "img/59fa29f.png";